// extracted by mini-css-extract-plugin
export default {"form-label":"Label_form-label__hxkkF","label-container":"Label_label-container__CY2Cb"};